export default {"src":"/_next/static/media/profile-picto.ece6f1bc.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};